import PropTypes from 'prop-types';

const FacetTextInput = ({ placeholder, value, handleTextChanged, disabled, param }) => {
  const handleChange = (e) => {
    handleTextChanged(param, e.target.value);
  };

  return (
    <div className="form-group">
      <input
        className="form-control"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        disabled={disabled}
      />
    </div>
  );
};

FacetTextInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  handleTextChanged: PropTypes.func,
  disabled: PropTypes.bool,
  param: PropTypes.string
};

FacetTextInput.defaultProps = {
  disabled: false
};

export default FacetTextInput;
